import React from 'react';
import {FaCalendar, FaCarSide, FaPalette} from "react-icons/fa";
import {FaWandMagicSparkles} from "react-icons/fa6";
import DivisorItem from "./divisor-item.jsx";
import Button from "../../../../../../../components/button/button.jsx";
import {navigateHook} from "../../../../../../../hooks/use-navigate.js";

const API_URL = import.meta.env.VITE_API_URL;

const VehicleDetails = ({data}) => {
    const navigate = navigateHook();

    const open = () => {
        const urlDev = `/vehicle/${data.plate}`
        navigate(urlDev, true);
    }

    return (
        <>
            <div className="border-top bg-[#f3f3f4]">
                <img className="m-auto !h-full"
                     src={`${API_URL}/passage/get-image/?url=${data.lastPassage}`}
                     onError={(e) => {
                         e.target.src = `${API_URL}/public/assets/img/sentry.imgnotfound.large.748x480.png`;
                     }}
                     alt="image"/>
            </div>
            <div className="vehicle-plate !w-full mx-auto !min-w-0 !border-none !rounded-none">
                <div className={"product-heading !rounded-t-[3px] " + (data.pattern ?? 'WITHOUT_PATTERN')}></div>
                <div className={"product-body " + (data.pattern ?? 'WITHOUT_PATTERN')}>
                    {data.formattedValue}
                </div>
            </div>
            <div className={"p-2"}>
                <DivisorItem icon={<FaCarSide size={18}/>} text={"Marca/Modelo"} value={data.brandModel}/>
                <DivisorItem icon={<FaCalendar size={18}/>} text={"Ano"} value={data.modelYear}/>
                <DivisorItem icon={<FaPalette size={18}/>} text={"Cor"} value={data.color}/>

                {
                    data?.coincidences &&
                    <DivisorItem icon={<FaWandMagicSparkles size={18}/>} text={"Coincidências"} value={data.coincidences}/>
                }

                {
                    data.plate &&
                    <Button onClick={open}>
                        Abrir cadastro
                    </Button>
                }
            </div>
        </>
    )
};

export default VehicleDetails;